var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DataListStateful',{attrs:{"title":"Черновики запросов","resource":"shipment-request-drafts","store":"shipmentRequestDrafts","columns":_vm.columns,"row-to":"shipment-request-new","allow-delete":true,"filter-options":_vm.filter,"add-route":{ name: 'shipment-request-new' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }